/**
 * Utility per la visibilità delle zone fisiologiche.
 *
 * is_displayable (da DB/zone.json):
 *   0 → Z0 (sentinella), REC, zone senza coefficienti validi (es. Z6/Z7 sci)
 *   1 → zone fisiologiche con range valido
 *
 * zonaIsDisplayable   → per oggetti zona dall'API (con da/a): usato in Zone.vue
 * zonaDefIsDisplayable → per definizioni statiche (zone.json): grafici/tabelle
 * zonaAndaturaIsDisplayable → come zonaDefIsDisplayable ma include REC
 */

import zoneJson from "@cached/zone.json"
export function getZona(id) {
    return zoneJson.find(z=>z.id===id);
}

const mapContextField = {
    'istogramma': 'show_in_istogrammi',
    'grafico': 'show_in_grafici',
    'select': 'show_in_select',
}
/**
 * Ritorna true se una zona (con campi da/a dall'API) deve essere mostrata.
 * Nasconde: Z0, REC, zone senza limite superiore valido (a nullo o zero).
 * @param {object} zona - oggetto zona dall'API con campi {id, da, a, ...}
 */
export function zonaIsDisplayable({id, a}, context) {
    const field = mapContextField[context];
    console.assert(field, `Context non valido: ${context}`);

    if(!field) return false;

    const def = getZona(id);
    const is_displayable = !!(def && def[field]);

    if(!is_displayable) return false;

    if (!a || a<0) return false;

    return true;
}

/**
 * Ritorna true se una definizione di zona (da zone.json, con is_displayable)
 * deve essere mostrata in grafici e tabelle.
 * Nasconde: Z0, REC, zone con is_displayable=0.
 * @param {object} zona - definizione zona da zone.json {id, codice, is_displayable, ...}
 */
export function zonaDefIsDisplayable(zona) {
    return !!zona.show_in_grafici;
}

/**
 * Ritorna true se una zona deve essere mostrata nel selettore andatura.
 * Come zonaDefIsDisplayable ma include REC (zona di recupero fermo).
 * @param {object} zona - definizione zona da zone.json {id, codice, is_displayable, ...}
 */
export function zonaAndaturaIsDisplayable(zona) {
    return !!zona.show_in_select;
}
